import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ClickAwayListener, Tooltip } from '@mui/material'
import CheckMarkIcon from '@src/icons/CheckMarkIcon'
import { FormattedMessage } from 'react-intl'
import CopyIcon from '@src/icons/CopyIcon'

const useStyles = makeStyles()((theme) => ({
  tooltip: {
    fontSize: theme.typography.pxToRem(11),
  },
  materialNumberText: {
    cursor: 'pointer',
    transition: 'background 100ms',
    '&:hover': {
      // Replicate browser text selected color
      backgroundColor: '#afd2fc',
    },
  },
  withIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(18),
    marginLeft: theme.spacing(2),
  },
}))

interface MaterialTextWithCopyProps {
  materialNumber: string
  isShowIcon?: boolean
}

const TooltipContent = () => {
  return (
    <span>
      <CheckMarkIcon style={{ marginRight: 6 }} fontSize="inherit" />
      <FormattedMessage
        id="COPIED_TO_CLIPBOARD"
        defaultMessage="Copied to Clipboard"
      />
    </span>
  )
}

const MaterialTextWithCopy: React.FC<MaterialTextWithCopyProps> = ({
  materialNumber,
  isShowIcon,
}) => {
  const { classes, cx } = useStyles()
  const [open, setOpen] = React.useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const handleClick = (materialNumber: string) => {
    navigator.clipboard.writeText(materialNumber)
    handleTooltipOpen()
    setTimeout(() => {
      handleTooltipClose()
    }, 750)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        PopperProps={{
          disablePortal: true,
        }}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={<TooltipContent />}
        placement="bottom"
        classes={{ tooltip: classes.tooltip }}
      >
        <span
          aria-hidden="true"
          onClick={() => handleClick(materialNumber)}
          onKeyDown={() => handleClick(materialNumber)}
          className={cx(classes.materialNumberText, {
            [classes.withIcon]: isShowIcon,
          })}
        >
          {materialNumber}
          {isShowIcon && (
            <CopyIcon color="primary" className={classes.copyIcon} />
          )}
        </span>
      </Tooltip>
    </ClickAwayListener>
  )
}

export default MaterialTextWithCopy
